/**
 * widgets/registry.geo.tsx — Mapa / geo widgety (OSM + customer filters).
 */
import { Map as MapIcon, Network } from 'lucide-react';
import type { WidgetRenderProps, WidgetSpec } from './types';
import { GeoMap } from '../components/geo/GeoMap';

function GeoMapWidget({ format }: WidgetRenderProps) {
  const f = format === 'sm' || format === 'md' || format === 'lg' ? format : 'lg';
  return (
    <div className='p-1'>
      <GeoMap format={f} showControls={f !== 'sm'} />
    </div>
  );
}

function GeoMapCompactWidget({ format }: WidgetRenderProps) {
  const f = format === 'sm' || format === 'md' || format === 'lg' ? format : 'md';
  return (
    <div className='p-1'>
      <GeoMap format={f} showControls={false} refreshMs={60_000} />
    </div>
  );
}

function GeoMapDefenceWidget({ format }: WidgetRenderProps) {
  const f = format === 'sm' || format === 'md' || format === 'lg' ? format : 'lg';
  return (
    <div className='p-1'>
      <GeoMap
        format={f}
        showControls={f !== 'sm'}
        preset='defence'
        defaultShowAttacks
        includeCallers={false}
        refreshMs={30_000}
      />
    </div>
  );
}

export const GEO_WIDGETS: WidgetSpec[] = [
  {
    id: 'geo.map',
    title: 'Mapa',
    module: 'geo',
    kind: 'custom',
    format: 'lg',
    formats: ['sm', 'md', 'lg'],
    icon: MapIcon,
    since: '2.1.0',
    component: GeoMapWidget,
  },
  {
    id: 'geo.map-compact',
    title: 'Mapa (kompakt)',
    module: 'geo',
    kind: 'custom',
    format: 'md',
    formats: ['sm', 'md', 'lg'],
    icon: Network,
    since: '2.1.0',
    component: GeoMapCompactWidget,
  },
  {
    id: 'geo.map-defence',
    title: 'Mapa útoků',
    module: 'geo',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: MapIcon,
    since: '2.1.0',
    component: GeoMapDefenceWidget,
  },
];
